'use strict';

(function () {
    'use strict';

    angular.module('zp').directive('travisCurrency', travisCurrency);

    travisCurrency.$inject = [];

    function travisCurrency() {

        var dir = {
            restrict: 'E',
            link: link,
            scope: {
                code: '='
            }
        };
        return dir;

        function link(scope, element, attrs) {

            element.text(getSymbolByCode(scope.code));
        }

        function getSymbolByCode(code) {

            switch (code) {

                case 'USD':
                    return '$';
                case 'CHF':
                    return 'CHF';
                case 'GBP':
                    return '£';
                case 'EUR':
                    return '€';
                default:
                    return '€';
            }
        }
    }
})();